import { ApiStoreKey } from 'enums';

import { useFetchApiToStore } from 'hooks/service';

export const useFetchApiClassDetail = (id: string) => {
  const { clearState, setState, fetchApi } = useFetchApiToStore<any, any>(ApiStoreKey.class, {
    url: `/classes/${id}`,
    method: 'GET',
  });

  return { fetchApiClassDetail: fetchApi, clearState, setState };
};
